export const handleInputValidation = (key, value) => {
  switch (key) {
    case "name":
      if (!value) {
        return "O campo Nome não pode ser vazio.";
      }

      if (typeof value !== "undefined") {
        if (!value.match(/^[0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/)) {
          return "O campo Nome não pode conter (@.$&*!?#%][]{}/-_).";
        }
        if (!value.match(/(\w.+\s).+/)) {
          return "O Nome deve ser completo neste campo.";
        }

        if(value.length < 3 || value.length > 128) {
          return 'Por favor, verifique se o nome digitado possui entre 3 e 128 caracteres.'
        }
      }
      break;
    case "contactEmail":
    case "email":
      if (!value) {
        return "O campo e-mail não pode ser vazio.";
      }

      if (typeof value !== "undefined") {
        let lastAtPos = value.lastIndexOf("@");
        let lastDotPos = value.lastIndexOf(".");

        if (
          !(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            value.indexOf("@@") === -1 &&
            lastDotPos > 2 &&
            value.length - lastDotPos > 2
          )
        ) {
          return "E-mail não é válido";
        }
      }
      break;
    case "type":
      if (!value) {
        return "O campo Tipo de Usuário não pode ser vazio.";
      }
      break;
    case "driverLicense":
      if (!value) {
        return "O campo CNH não pode ser vazio.";
      }
      if (typeof value !== "undefined") {
        if (!value.match(/^[0-9]*$/)) {
          return "A CNH só deve conter apenas números.";
        }
      }
      break;
    case "driverLicenseExpiration":
      if (!value) {
        return "O campo Validade não pode ser vazio.";
      }
      if (typeof value !== "undefined") {
        if (!value.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
          return "A validade da CNH deve ser dd/mm/aaaa.";
        }
      }
      break;
    case "tollNumber":
      if (typeof value !== "undefined") {
        if (!value.match(/^[0-9]*$/)) {
          return "O Cartão Pedágio deve conter apenas números positivos.";
        }
        if (value.length > 0 && value.length !== 8) {
          if (value.length > 0 && value.length !== 10) {
            return "O Cartão Pedágio deve conter um número válido.";
          }
        }
      }
      break;
    case "CNPJ":
      if (!value) {
        return "O campo CNPJ não pode ser vazio.";
      }
      if (typeof value !== "undefined") {
        if (!value.match(/[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}/i)) {
          return "Digite os 14 caracteres do CNPJ";
        }
      }
      break;
    default:
      break;
  }
};

export const formatCnpjToBaseNumbers = (cnpj) => {
  if (cnpj.length === 15) {
    const newCNPJ = cnpj.substr(1, 8);
    return newCNPJ;
  }
  if (cnpj.length === 14) {
    const newCNPJ = cnpj.substr(0, 8);
    return newCNPJ;
  }
};

// Converte um caractere alfanumérico do CNPJ para seu valor numérico (Serpro 2026).
// Dígitos 0-9 retornam 0-9; letras A-Z retornam 10-35.
const cnpjCharToValue = (char) => {
  return char.toUpperCase().charCodeAt(0) - 48;
};

export const validateCpfCnpj = (rawDocumentNumber = "") => {
  // Remove apenas separadores de formatação; preserva letras do CNPJ alfanumérico
  const documentNumber = rawDocumentNumber.replace(/[.\-/\s]/g, "").toUpperCase().trim();
  if (!documentNumber.length) return true;

  if (documentNumber.length === 11) {
    let cpf = documentNumber;
    let aux = false;
    let i = 0,
      v1 = 0,
      v2 = 0,
      p = 0;

    for (i = 1; cpf.length > i; i++) {
      if (cpf[i - 1] !== cpf[i]) {
        aux = true;
      }
    }

    if (aux === false) {
      return false;
    }

    for (i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
      v1 += cpf[i] * p;
    }

    v1 = (v1 * 10) % 11;

    if (v1 === 10) {
      v1 = 0;
    }

    if (v1 !== parseInt(cpf[9])) {
      return false;
    }

    for (i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
      v2 += cpf[i] * p;
    }

    v2 = (v2 * 10) % 11;

    if (v2 === 10) {
      v2 = 0;
    }

    if (v2 !== parseInt(cpf[10])) {
      return false;
    } else {
      return true;
    }
  } else if (documentNumber.length === 14) {
    let cnpj = documentNumber;
    let aux = false;
    let i = 0,
      v1 = 0,
      v2 = 0,
      p1 = 0,
      p2 = 0;

    for (i = 1; cnpj.length > i; i++) {
      if (cnpj[i - 1] !== cnpj[i]) {
        aux = true;
      }
    }

    if (aux === false) {
      return false;
    }

    for (i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
      if (p1 >= 2) {
        v1 += cnpjCharToValue(cnpj[i]) * p1;
      } else {
        v1 += cnpjCharToValue(cnpj[i]) * p2;
      }
    }

    v1 = v1 % 11;

    if (v1 < 2) {
      v1 = 0;
    } else {
      v1 = 11 - v1;
    }

    if (v1 !== parseInt(cnpj[12])) {
      return false;
    }

    for (i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
      if (p1 >= 2) {
        v2 += cnpjCharToValue(cnpj[i]) * p1;
      } else {
        v2 += cnpjCharToValue(cnpj[i]) * p2;
      }
    }

    v2 = v2 % 11;

    if (v2 < 2) {
      v2 = 0;
    } else {
      v2 = 11 - v2;
    }

    if (v2 !== parseInt(cnpj[13])) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};
